module.exports = __webpack_public_path__ + "static/media/sims_logo_loading.ecc8d561.png";